import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import CategoryManager from '@/components/v2/ecommerce/CategoryManager.vue';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import PsgcRegions from '@/components/v2/PsgcRegions';
import PsgcCities from '@/components/v2/PsgcCities';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import SegmentationTypeMixin from '@/helpers/vue_mixins/v2/SegmentationTypeMixin';
import ServiceBundleSegments from '@/components/v2/ServiceBundleSegments';
import ShippingMethodManager from '@/components/v2/ShippingMethodManager.vue';
import StoreManager from '@/components/v2/store_management/StoreManager.vue';
import { SurveySegmentationType } from '@/helpers/entities/enums/v2/SurveySegmentationType';
import { required } from 'vuelidate/lib/validators';
import { SEGMENT } from '@/helpers/constants/Store';
import { Getter, Mutation } from 'vuex-class';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
import { EcommerceSegmentationType } from '@/helpers/entities/enums/v2/EcommerceSegmentationType';
import { InquirySegmentationType } from '@/helpers/entities/enums/v2/InquirySegmentationType';
import { PsgcRegionModel } from '@/helpers/entities/models/PsgcRegionModel';
import { startCase } from 'lodash';
let CustomerSegmentationForm = class CustomerSegmentationForm extends mixins(FormMixin, FormValidationsMixin, SegmentationTypeMixin, ViewportSizeMixin, RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            name: null,
            categories: [],
        };
    }
    capitalizeSegmentLabel(name) {
        return startCase(name);
    }
    get ecommerceSegmentations() {
        return Object.values(EcommerceSegmentationType)
            .map((segment) => {
            const segmentTitle = startCase(segment);
            return this.buildRulesFor(segment, segmentTitle);
        })
            .filter(({ category }) => this.bundle === Bundle.MultiStore
            ? category !== EcommerceSegmentationType.Category
            : category !== EcommerceSegmentationType.Store);
    }
    get surveySegmentations() {
        return Object.values(SurveySegmentationType).map((segment) => {
            const segmentTitle = startCase(segment);
            return { rules: [{ uuids: null }], category: segment, label: segmentTitle };
        });
    }
    get inquirySegmentations() {
        return Object.values(InquirySegmentationType).map((segment) => {
            const segmentTitle = startCase(segment);
            return { rules: [{ uuids: null }], category: segment, label: segmentTitle };
        });
    }
    get segmentationTypes() {
        switch (this.bundle) {
            case Bundle.Ecommerce:
                return this.ecommerceSegmentations;
            case Bundle.Survey:
                return this.surveySegmentations;
            case Bundle.Inquiry:
                return this.inquirySegmentations;
            default:
                return this.ecommerceSegmentations;
        }
    }
    get productManagerTemplate() {
        switch (this.bundle) {
            case Bundle.Ecommerce:
                return () => import('@/components/v2/ecommerce/ProductManager.vue');
            case Bundle.Inquiry:
                return () => import('@/components/v2/inquiry/CategoryProducts');
            default:
                return () => import('@/components/v2/ecommerce/ProductManager.vue');
        }
    }
    buildRulesFor(segment, segmentLabel) {
        return {
            rules: [{ uuids: null, products: [], cities: [] }],
            category: segment,
            label: segmentLabel,
        };
    }
    isInterest(category) {
        return category === SurveySegmentationType.interest;
    }
    onAddCategory(key) {
        this.form.categories[key].rules.push({ uuids: null, products: [] });
    }
    onAddLocation(key) {
        this.form.categories[key].rules.push({ uuids: null, cities: [] });
    }
    onHide() {
        this.hideForm();
    }
    isShipping(category) {
        return EcommerceSegmentationType.Shipping === category;
    }
    onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.$emit('submit', this.form);
        }
    }
};
__decorate([
    Getter('toggleForm', { namespace: SEGMENT })
], CustomerSegmentationForm.prototype, "toggleForm", void 0);
__decorate([
    Getter('requestOnFlight')
], CustomerSegmentationForm.prototype, "mutationRequestOnFlight", void 0);
__decorate([
    Mutation('hideForm', { namespace: SEGMENT })
], CustomerSegmentationForm.prototype, "hideForm", void 0);
__decorate([
    Prop({ type: String, required: true })
], CustomerSegmentationForm.prototype, "bundle", void 0);
CustomerSegmentationForm = __decorate([
    Component({
        components: {
            ActionButton,
            BaseSubtitle,
            BaseTextField,
            CategoryManager,
            PsgcRegions,
            PsgcCities,
            ServiceBundleSegments,
            ShippingMethodManager,
            StoreManager,
        },
        validations() {
            const vm = this;
            const unique = (val) => {
                if (!val) {
                    return true;
                }
                const matches = [];
                vm.form.categories.forEach((cat) => {
                    cat.rules.forEach((rule) => {
                        if (val instanceof PsgcRegionModel) {
                            const uuids = rule.uuids;
                            if (!!val && uuids && uuids.regionCode === val.regionCode) {
                                matches.push(uuids.regionCode);
                            }
                        }
                        else if (!!val && rule.uuids === val) {
                            matches.push(rule.uuids);
                        }
                    });
                });
                return matches.length <= 1;
            };
            return {
                form: {
                    name: {
                        required,
                    },
                    categories: {
                        required,
                        $each: {
                            rules: {
                                $each: {
                                    uuids: {
                                        required,
                                        unique,
                                    },
                                    products: {},
                                    cities: {},
                                },
                            },
                            category: {
                                required,
                            },
                            label: {},
                        },
                    },
                },
            };
        },
    })
], CustomerSegmentationForm);
export default CustomerSegmentationForm;
